export default function claudinaryImage(src) {
  return `https://res.cloudinary.com/absolutandres/image/upload/c_scale,f_auto,fl_progressive,q_auto${src}`;
}
